<template>
    <div class="file-uploading">
        <a-progress :showInfo="false" :percent="percentage" status="active" />
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";

const log = log2("FileUploading");
export default {
    name: "FileUploading",
    props: {
        percentage: {
            type: Number,
            default: 0,
        },
    },
};
</script>
<style lang="scss" scoped>
.file-uploading {
    width: 100%;
    background: #22272d;
    padding: 6px 10px;
    color: white;
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>
